import * as React from 'react';
import { IProfile } from '../../lib/types/Profile';

interface IProps {
  details: IProfile;
}

function genderString(gender?: string): string {
  return {
    female: 'Frau',
    male: 'Herr',
    unknown: '',
  }[gender || 'unknown'];
}

export default function UserProfile(props: IProps) {
  const {
    gender,
    firstName,
    lastName,
    street,
    postalCode,
    city,
  } = props.details;

  return (
    <address>
      <div>
        {genderString(gender)} {firstName} {lastName}
      </div>
      <div>{street}</div>
      <div>
        {postalCode} {city}
      </div>
    </address>
  );
}



// WEBPACK FOOTER //
// ./src/components/ConfirmPurchase/UserProfile.tsx